import { CommonModule } from '@angular/common';
import { Component, ElementRef, Input, Optional, Self, ViewChild } from '@angular/core';
import { ControlValueAccessor, FormsModule, NgControl } from '@angular/forms';
import { PasswordModule } from 'primeng/password';
import { FormErrorMessageDirective } from '../../../directives/form-error-message.directive';
import { DividerModule } from 'primeng/divider';
import { TranslateService } from '../../../../i18n/translate.service';

@Component({
  selector: 'app-password',
  standalone: true,
  imports: [CommonModule, PasswordModule, FormsModule, FormErrorMessageDirective, DividerModule],
  templateUrl: './password.html',
  styleUrl: './password.scss',
})
export class Password implements ControlValueAccessor {
  @ViewChild('inputRef') inputRef!: any;

  @Input() label = '';
  @Input() labelCustomClass = '';
  @Input() inputCustomClass = '';
  @Input() placeholder: string = 'Enter your password';
  @Input() submitted: boolean = false;
  @Input() showValidationHints: boolean = false;

  value = '';
  disabled = false;

  onChange = (_: any) => { };
  onTouched = () => { };

  constructor(@Optional() @Self() public ngControl: NgControl, readonly i18n: TranslateService) {
    if (this.ngControl) {
      this.ngControl.valueAccessor = this;
    }
  }

  writeValue(value: any): void {
    this.value = value || '';
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  onInput(value: string): void {
    this.value = value;
    this.onChange(this.value);
  }

  focusInput() {
    this.inputRef?.input.nativeElement?.focus();
  }
}
